import * as angular from 'angular';
import {IController, IOnChangesObject, IScope} from 'angular';
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class DeliveriesDragTableRowComponent implements IController {

  id: any;
  columns: any;
  isSelected: any;
  toggle: Function;
  onDragStart: Function;

  public locationTypes: typeof LocationType = LocationType;
  private service: any;
  private configZoneId: any;

  constructor(private $delivery, private IAMPermissions, private splitService: SplitService,
              private $scope: IScope, private $element) {
    this.configZoneId = this.splitService.getTimeZone();
  }

  $onInit() {
    if (this.id) {
      this.bindService();
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.bindService();
    }
  };

  $postLink() {
    this.$element.on('dragstart', (event) => {
      this.onDragStart({service: this.service, event: event});
    });
  }

  private bindService() {
    this.service = undefined;
    this.$delivery(this.id).$bindCtrlToId(this.$scope, this, 'service', 'id');
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesDragTableRow', {
    bindings: {
      id: '<',
      columns: '<?',
      isSelected: '<',
      toggle: '&',
      onDragStart: '&'
    },
    template: require('./deliveries-drag-table-row.html').default,
    controller: DeliveriesDragTableRowComponent
  });
